import {getRequest} from '@requests';
import {addNotification, openWrongPage} from '@componentDP/js_react/redux/actions/application';
import {mappingZajavls, mappingRatingApplicantsLinks} from '@componentDP/js_react/helpers/mapping_fields';
import {
    ZAJAVLS,
    SET_LOADING_RATING_APPLICANTS,
    SET_LOADED_RATING_APPLICANTS,
    SET_RATING_APPLICANTS_LINKS,
} from '@componentDP/js_react/redux/store/actionTypes';
import {v4 as uuid} from 'uuid';
import {setUidContests} from '@helpers/functions';

export const initializationRatingApplicants = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: SET_LOADING_RATING_APPLICANTS,
            });
            const {apiDomainVikon} = getState();
            const ratingApplicants = await getRequest(`${apiDomainVikon}api/digital_profile/applicant/rating`);
            const {zajavls, links} = ratingApplicants;
            for (const zajavl of zajavls) {
                zajavl.uuid = uuid();
                zajavl.contests = setUidContests(zajavl.request_competitions);
                delete zajavl.request_competitions;
            }
            const zajavlsMapped = mappingZajavls(zajavls);
            const ratingApplicantsLinksMapped = mappingRatingApplicantsLinks(links);
            dispatch({
                type: ZAJAVLS,
                list: zajavlsMapped,
            });
            dispatch({
                type: SET_RATING_APPLICANTS_LINKS,
                payload: ratingApplicantsLinksMapped,
            });
            dispatch({
                type: SET_LOADED_RATING_APPLICANTS,
            });
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
            dispatch(openWrongPage());
        }
    };
};
